import {Stringifier} from '../../services/stringifier.service';

import {FInt} from '../../services/filters/int-filter';
import {FString} from '../../services/filters/string-filter';
import {FBoolean} from '../../services/filters/boolean-filter';
import {FDate} from '../../services/filters/date-filter';
import {FEnum} from '../../services/filters/enum-filter';
import {BaseFilterRequest} from './base-filter-request';

@Stringifier
export class FilterUsersRequest extends BaseFilterRequest {
    userId?: FInt;
    username?: FString;
    active?: FBoolean;
    createdAt?: FDate;
    // userType?: FEnum;
    sequentialRequestId: number = 0;

    static getStringifier(level: number): FilterUsersRequest | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            userId: null,
            username: null,
            active: null,
            createdAt: null,
            sequentialRequestId: null,
        } as FilterUsersRequest;
    }
}

